const riot = require('riot');

riot.tag2('module-calendar-mini', '<div class="f fm fbw mb12"> <div class="f fh flex-fixed s21 circle hover-trigger hover-bg-dark cursor-pointer" onclick="{onPrev}"><i class="icon-arrow-left pb2 fs16"></i></div> <div class="fs14 lh15" if="{base}">{base.format(\'YYYY年 MM月\')}</div> <div class="f fh flex-fixed s21 circle hover-trigger hover-bg-dark cursor-pointer" onclick="{onNext}"><i class="icon-arrow-right pb2 fs16"></i></div> </div> <div class="row"> <div class="px8 text-center border-bottom border-label_disabled mb8" each="{week, index in weeks}" riot-style="width: {100/7}%"> <div class="f fh text-center fs11 lh15">{week}</div> </div> <div class="f fh cursor-pointer hover-trigger" riot-style="width: {100/7}%" each="{date in dates}" onclick="{onSelect}"> <div class="relative f fh flex-fixed s32 square rounded-4 {getDateClass(date)}"> <div class="f fh font-lato lh15 fs12 text-center">{date.date()} <div class="absolute b4 w50per h2 bg-label_low rounded-full" if="{date.isSame(Date.now(),\'date\')}"></div> </div> </div> </div> </div>', '', '', function(opts) {

    this.weeks = ["月", "火", "水", "木", "金", "土", "日"];

    this.on('mount', () => {
      this.setup();
    });

    this.setup = (base) => {
      this.base = base || dayjs();

      const start = this.base.startOf('month');

      const end = this.base.endOf('month');

      this.dates = Array(end.date()).fill(0).map((v, i) => {

        return start.add(i, 'day').endOf('date');
      });

      var prev_month_date_num = ((start.day() + this.weeks.length)-1) % this.weeks.length;
      Array(prev_month_date_num).fill(0).forEach((v, i) => {
        this.dates.unshift(start.add(-(i+1), 'day').endOf('date'));
      });

      var next_month_date_num = this.weeks.length * 6 - this.dates.length;
      Array(next_month_date_num).fill(0).forEach((v, i) => {
        this.dates.push(end.add(i+1, 'day').endOf('date'));
      });
      this.update();
    };

    this.onPrev = () => {
      this.setup(this.base.add(-1, 'month'));
    };

    this.onNext = () => {
      this.setup(this.base.add(1, 'month'));
    };

    this.getDateClass = (date) => {
      var class_name = "";

      if (!date.isSame(this.base, "month")) {

        if (date.isSame(Date.now(),"date")) {
          class_name += "bg-primary text-white ";
        }
        else {
          class_name += "text-label_disabled ";
        }
      }

      if (date.isSame(this.opts.startDate || Date.now(),"date")) {
        class_name += "bg-primary text-white ";
      }

      else {
        class_name += "hover-bg-dark ";
      }
      return class_name;
    };

    this.onSelect = (e) => {
      var date = dayjs(e.item.date).format('YYYY-MM-DD');
      this.bubbleTrigger('calendarselect', date);
    }
});